import { QuickActionsConstants } from '../store/quickActions.constants'
import { takeLatest } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { getUserIdSelector } from '../../user/selectors'
import { getVitalOptionsSelector } from '../../options/selectors'
import { IVitalOptionsState, IDrainOptionsState } from '../../options/store/options.types'
import { setAddDrainToTimeline } from '../store/quickActions.actions'
import { getDrainSelector } from '../../procedures/drain/selectors'
import { IDrainState } from '../../procedures/drain/store/drain.types'
import { saveDrain, setDrainState } from '../../procedures/drain/store/drain.actions'
import { getDrainOptionsSelector } from '../../options/selectors'

export function* setDrainQuickAction() {
  const userId: string = yield select(getUserIdSelector)
  const quickActionsState = yield select(getQuickActionsSelector)
  const { selectedQuickActionButton } = quickActionsState
  const { props } = selectedQuickActionButton
  const { savedTimeString, currentDate, procedureAction } = props
  const vitalsOptionsState: IVitalOptionsState = yield select(getVitalOptionsSelector)
  const { assessedByOptions } = vitalsOptionsState
  const assessedByOption = assessedByOptions.find((option) => option.id === +userId)

  const drainOptions: IDrainOptionsState = yield select(getDrainOptionsSelector)
  const { actionOptions } = drainOptions
  const actionOption = actionOptions.find((option) => option.id === procedureAction)

  const drainState: IDrainState = yield select(getDrainSelector)

  yield put(
    setDrainState({
      ...drainState,
      date: currentDate,
      time: savedTimeString,
      assessedBy: assessedByOption || null,
      successfulAttempt: true,
      attempts: '1',
      action: actionOption || null,
    })
  )
  yield put(saveDrain())
  yield put(setAddDrainToTimeline(true))
}

export function* setDrainQuickActionSaga() {
  yield takeLatest([QuickActionsConstants.SET_IS_DRAIN_BUTTON_TYPE], setDrainQuickAction)
}
